<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->

      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img fluid :src="imgUrl" alt="Login V2" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title class="mb-1 font-weight-bold" title-tag="h2">
            Bem-vindo ao ArboEdu!
          </b-card-title>
          <b-card-text class="mb-2">
            Insira os seus dados para acessar o sistema
          </b-card-text>

          <!-- <b-alert
            variant="primary"
            show
          >
            <div class="alert-body font-small-2">
              <p>
                <small class="mr-50"><span class="font-weight-bold">Admin:</span> admin@demo.com | admin</small>
              </p>
              <p>
                <small class="mr-50"><span class="font-weight-bold">Client:</span> client@demo.com | client</small>
              </p>
            </div>
            <feather-icon
              v-b-tooltip.hover.left="'This is just for ACL demo purpose'"
              icon="HelpCircleIcon"
              size="18"
              class="position-absolute"
              style="top: 10; right: 10;"
            />
          </b-alert> -->

          <!-- form -->
          <validation-observer ref="loginForm" #default="{ invalid }">
            <b-form class="auth-login-form mt-2" @submit.prevent="login">
              <!-- email -->
              <b-form-group label="Email" label-for="login-email">
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  vid="email"
                  rules="required"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false : null"
                    name="login-email"
                    placeholder="Seu email"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Senha</label>
                  <b-link :to="{ name: 'auth-forgot-password' }">
                    <small>Esqueceu a senha?</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="Password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Lembrar-me
                </b-form-checkbox>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="invalid"
              >
                Login
              </b-button>
            </b-form>
          </validation-observer>

          <!-- <b-card-text class="text-center mt-2">
            <span>Novo na plataforma?</span>
            <b-link :to="{ name: 'auth-register' }">
              <span>&nbsp;Crie uma conta agora</span>
            </b-link>
          </b-card-text> -->

          <!-- divider -->
          <!-- <div class="divider my-2">
            <div class="divider-text">ou</div>
          </div> -->

          <!-- social buttons -->
          <!-- <div class="auth-footer-btn d-flex justify-content-center">
            <b-button variant="facebook" href="javascript:void(0)">
              <feather-icon icon="FacebookIcon" />
            </b-button>
            <b-button variant="twitter" href="javascript:void(0)">
              <feather-icon icon="TwitterIcon" />
            </b-button>
            <b-button variant="google" href="javascript:void(0)">
              <feather-icon icon="MailIcon" />
            </b-button>
            <b-button variant="github" href="javascript:void(0)">
              <feather-icon icon="GithubIcon" />
            </b-button>
          </div> -->
          <!-- Apoio -->
          <div class="mt-4 text-center">
            <span class="text-muted d-block mb-1 font-small-3">Apoio:</span>
            <div class="d-flex align-items-center justify-content-center flex-wrap">
              <b-img
                :src="baseUrl + 'assets/images/brasao-ufpe.png'"
                alt="UFPE"
                style="max-height: 45px; width: auto;"
                class="mx-1 mb-1"
              />
              <b-img
                :src="baseUrl + 'assets/images/capes.png'"
                alt="CAPES"
                style="max-height: 35px; width: auto;"
                class="mx-1 mb-1"
              />
              <b-img
                :src="baseUrl + 'assets/images/selo-ods-educacao.png'"
                alt="ODS"
                style="max-height: 60px; width: auto;"
                class="mx-1 mb-1"
              />
            </div>
          </div>
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>

    <!-- Modal para Estudantes -->
    <b-modal
      id="modal-estudante-app"
      title="Acesso Restrito"
      size="md"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="text-center">
        <div class="mb-3">
          <feather-icon 
            icon="SmartphoneIcon" 
            size="48" 
            class="text-primary"
          />
        </div>
        <h4 class="mb-3">Acesso via Aplicativo</h4>
        <p class="mb-4">
          Estudantes devem acessar o sistema através do aplicativo móvel.
        </p>
        <div class="mb-4">
          <b-button 
            variant="primary" 
            size="lg"
            href="https://app.arboedu.org"
            class="mr-2"
          >
            <feather-icon icon="ExternalLinkIcon" size="16" class="mr-2" />
            Acessar App
          </b-button>
        </div>
        </div>
      </b-modal>

    <!-- Modal para Alteração de Senha -->
    <b-modal
      id="modal-alterar-senha"
      title="Alteração de Senha Obrigatória"
      size="md"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="text-center mb-3">
        <feather-icon 
          icon="ShieldIcon" 
          size="48" 
          class="text-warning"
        />
      </div>
      
      <h4 class="text-center mb-4">Alteração de Senha Necessária</h4>
      <p class="text-center mb-4">
        Por motivos de segurança, você deve alterar sua senha antes de continuar.
      </p>

      <validation-observer ref="alterarSenhaForm" #default="{ invalid }">
        <b-form @submit.prevent="alterarSenha">
          <b-form-group label="Nova Senha" label-for="nova-senha">
            <validation-provider
              #default="{ errors }"
              name="Nova Senha"
              rules="required|min:6"
            >
              <b-input-group 
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <b-form-input
                  id="nova-senha"
                  v-model="novaSenha"
                  :type="passwordFieldType"
                  placeholder="Digite sua nova senha"
                  :state="errors.length > 0 ? false : null"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    :icon="passwordToggleIcon"
                    class="cursor-pointer"
                    @click="togglePasswordVisibility"
                  />
                </b-input-group-append>
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group label="Confirmar Nova Senha" label-for="confirmar-senha">
            <validation-provider
              #default="{ errors }"
              name="Confirmar Senha"
              rules="required|min:6"
            >
              <b-input-group 
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <b-form-input
                  id="confirmar-senha"
                  v-model="confirmarSenha"
                  :type="passwordFieldType"
                  placeholder="Confirme sua nova senha"
                  :state="errors.length > 0 ? false : null"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    :icon="passwordToggleIcon"
                    class="cursor-pointer"
                    @click="togglePasswordVisibility"
                  />
                </b-input-group-append>
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <div class="text-center">
            <b-button
              type="submit"
              variant="primary"
              size="lg"
              :disabled="invalid || isChangingPassword"
              class="w-100"
            >
              <b-spinner v-if="isChangingPassword" small class="mr-1" />
              {{ isChangingPassword ? 'Alterando...' : 'Alterar Senha' }}
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable global-require */
import useJwt from '@/auth/jwt/useJwt'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import utilsService from '@/services/utilsService'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { email, required } from '@validations'
import {
BAlert, BButton, BCardText,
BCardTitle, BCol, BForm, BFormCheckbox, BFormGroup,
BFormInput, BImg, BInputGroup, BInputGroupAppend, BLink, BRow, VBTooltip
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      userEmail: '',
      sideImg: require('@/assets/images/auth/arboedu_white_icon.png'),
      rememberMe: false,
      
      // Dados para alteração de senha
      tempUserData: null,
      novaSenha: '',
      confirmarSenha: '',
      isChangingPassword: false,

      // validation rules
      required,
      email,
      baseUrl: process.env.BASE_URL,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/auth/arboedu_white_icon.png')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    login() {
      this.$refs.loginForm.validate().then(async success => {
        if (success) {
          await useJwt
            .login({
              login: this.userEmail,
              password: this.password,
              rememberMe: this.rememberMe,
            })
            .then(async res => {
              if (!res) {
                throw new Error('Erro')
              }
              if (res.data.user.role?.toLowerCase() === "student") {
                this.$bvModal.show('modal-estudante-app')
                return
              }
              
              // Verifica se o usuário deve alterar a senha
              if (res.data.user.deveAlterarSenha === true) {
                // Salva dados temporários para alteração de senha
                this.tempUserData = {
                  id: res.data.user.id,
                  email: res.data.user.email,
                  fullName: res.data.user.fullName,
                  token: res.data.token
                }
                this.$bvModal.show('modal-alterar-senha')
                return
              }
              
              useJwt.setToken(res.data.token)
              useJwt.setRefreshToken(res.data.token)
              const userData = {
                id: res.data.user.id,
                fullName: res.data.user.fullName || 'Nome Completo',
                username: res.data.username || 'Seu Login',
                password: 'admin1',
                // eslint-disable-next-line global-require
                avatar: require('@/assets/images/avatars/13-small.png'),
                email: res.data.user.email || 'Seu Email',
                role: res.data.user.role || 'admin',
                ability: [
                  {
                    action: 'manage',
                    subject: 'all',
                  },
                ],
                extras: {
                  eCommerceCartItemsCount: 5,
                },
              }
              localStorage.setItem('userData', JSON.stringify(userData))
              this.$ability.update(userData.ability)

              // ? This is just for demo purpose as well.
              // ? Because we are showing eCommerce app's cart items count in navbar
              // this.$store.commit(
              //   'app-ecommerce/UPDATE_CART_ITEMS_COUNT',
              //   userData.extras.eCommerceCartItemsCount
              // )

              // ? This is just for demo purpose. Don't think CASL is role based in this case, we used role in if condition just for ease
              console.log(userData)
              this.$router
                .replace(getHomeRouteForLoggedInUser(userData.role))
                .then(() => {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: `Bem vindo(a), ${
                        userData.fullName || userData.username
                      }`,
                      icon: 'CoffeeIcon',
                      variant: 'success',
                      text: `Você está logado como ${utilsService.getTitleRole(
                        userData.role
                      )}.`,
                    },
                  })
                })
            })
            .catch(error => {
              console.log(error)
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Erro ao Realizar Login',
                  icon: 'AlertIcon',
                  variant: 'danger',
                  text: 'Verifique os Campos.',
                },
              })
              // this.$refs.loginForm.setErrors(error.response.data.error)
            })
        }
      })
    },

    async alterarSenha() {
      this.$refs.alterarSenhaForm.validate().then(async success => {
        if (success) {
          if (this.novaSenha !== this.confirmarSenha) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Erro na Confirmação',
                icon: 'AlertIcon',
                variant: 'danger',
                text: 'As senhas não coincidem.',
              },
            })
            return
          }

          this.isChangingPassword = true
          
          try {
            // Chama o serviço para alterar a senha
            const response = await this.$http.post('/auth/change-password', {
              userId: this.tempUserData.id,
              newPassword: this.novaSenha,
              currentPassword: this.password
            })

            // Senha alterada com sucesso, agora faz o login normal
            this.$bvModal.hide('modal-alterar-senha')
            
            // Limpa o formulário de alteração
            this.password = this.novaSenha;
            this.novaSenha = ''
            this.confirmarSenha = ''
            this.tempUserData = null
            // Faz o login novamente
            await this.login()
            
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Senha Alterada',
                icon: 'CheckIcon',
                variant: 'success',
                text: 'Sua senha foi alterada com sucesso!',
              },
            })
          } catch (error) {
            console.error('Erro ao alterar senha:', error)
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Erro ao Alterar Senha',
                icon: 'AlertIcon',
                variant: 'danger',
                text: 'Não foi possível alterar a senha. Tente novamente.',
              },
            })
          } finally {
            this.isChangingPassword = false
          }
        }
      })
    },

    resetAlterarSenhaForm() {
      this.novaSenha = ''
      this.confirmarSenha = ''
      this.tempUserData = null
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
